<template>
  <div class="Map">
    <p>Click on the map to choose GPS Location</p>
    <div class="info">
      <el-input size="small" style="width: 200px; margin-right: 10px" v-model="keyword"
                placeholder="Enter keyword"></el-input>
      <el-input size="small" style="width: 200px; margin-right: 30px" v-model="location"
                placeholder="Enter region"></el-input>
      <div class="action">
        <el-button size="small" @click="onConfirm" :disabled="lat===0||lng===0" type="primary">Confirm Location
        </el-button>
      </div>

    </div>

    <baidu-map
        v-if="show_map"
        class="map"
        :center="center"
        :zoom="zoom"
        :scroll-wheel-zoom="true"
        @click="onLocationSelect"
        @moving="syncCenterAndZoom"
        @moveend="syncCenterAndZoom"
        @zoomend="syncCenterAndZoom">
      <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
      <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
      <bm-marker v-if="lat!==0&&lng!==0" :position="{lng: lng, lat: lat}"></bm-marker>
      <bm-local-search :panel="false" :keyword="keyword" :auto-viewport="true" :location="location"></bm-local-search>
    </baidu-map>
  </div>

</template>

<script>
  export default {
    props: ['vlat', 'vlng'],
    data: () => {
      return {
        show_map:false,
        center: {
          lat: 23.134971,
          lng: 113.268935,
        },
        lat: 0,
        lng: 0,
        zoom: 12,
        location: '',
        keyword: '',
      }
    },
    methods: {
      syncCenterAndZoom(e) {
        const {lng, lat} = e.target.getCenter();
        this.center.lng = lng;
        this.center.lat = lat;
        this.zoom = e.target.getZoom()
      },
      onConfirm() {
        if (this.lat !== 0 && this.lng !== 0) {
          this.center = {
            lat: this.lat,
            lng: this.lng,
          };
          let location = {
            lat: this.lat,
            lng: this.lng,
          };
          this.$emit('confirm', location)
        }

      },
      onLocationSelect(e) {
        this.lat = e.point.lat;
        this.lng = e.point.lng;
      }
    },
    mounted() {
      if (this.vlat !== 0 && this.vlng !== 0) {
        this.center = {lng: this.vlng, lat: this.vlat}
      }
      this.lat = this.vlat;
      this.lng = this.vlng;
      this.show_map = true
    }
  }
</script>

<style lang="scss" scoped>
  @import "_Map.scss";
</style>